// Copyright (c) 2026, Dokos SAS and contributors
// License: MIT. See LICENSE

frappe.provide("frappe.email_group_dialog");

// @dokos
frappe.email_group_dialog.show ??= async (options = {}) => {
	const snapshot = { ...options, docnames: options.docnames?.slice() };
	try {
		await frappe.require("email_group_dialog.bundle.js");
	} catch (error) {
		frappe.msgprint({
			message: __("Unable to open the mailing list dialog. Please try again."),
			indicator: "red",
		});
		throw error;
	}
	return frappe.email_group_dialog.show(snapshot);
};
